<div class="cancel-freshpass-container">
    <div *ngIf="showLoader" class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 container p0">
            <div class="loading-div-tiny" id="freshpass-loading">
                <div class="loading-spinner">
                    <div alt="Loading..." class="large progress">
                        <div class="prog1">
                            <div class="prog2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!showLoader">
        <app-cancel-freshpass (cancelSuccessResponse)="cancelPlanResponseHandler($event)"
                              [cancelReasonsData]="cancelReasonsData"
                              [currentEnvironment]="currentEnvironment"
                              [userInfo]="userInfo"
                              [userSubscriptionDetails]="userSubscriptionDetails">
        </app-cancel-freshpass>
    </div>
</div>


